module.exports = __webpack_public_path__ + "img/08-02_Adapting To Others.02f9b80d.svg";